import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToCart, removeCartItem } from '../../redux/actions/cartActions';
import { toast } from 'react-hot-toast';

const CartItemCard = ({ item }) => {
    const dispatch = useDispatch();

    const handleQuantity = (type) => {
        if (type === 'INCREMENT') {
            if (item.stock <= item.quantity) {
                return;
            }
            dispatch(addToCart(item.product, item.quantity + 1));
        } else if (type === 'DECREMENT') {
            if (item.quantity <= 1) {
                return;
            }
            dispatch(addToCart(item.product, item.quantity - 1));
        }
    };

    const handleRemoveCartItem = () => {
        dispatch(removeCartItem(item.product));
        toast.success('Item removed successfully');
    };

    return (
        <div>
            <div className='cartItemCard'>
                <div className='d-flex'>
                    <img src={item.image} alt={item.name} />
                    <div className='ps-2'>
                        <Link to={`product/${item.product}`}>{item.name}</Link>
                        <span>{`Price: ₹${item.price}`}</span>
                        <p onClick={handleRemoveCartItem} className='removeBtn'>
                            Remove
                        </p>
                    </div>
                </div>
                <div className='qty justify-content-center'>
                    <button className='incDecBtn' onClick={() => handleQuantity('DECREMENT')}>
                        -
                    </button>
                    <input type='number' className='form-control' value={item.quantity} readOnly />
                    <button className='incDecBtn' onClick={() => handleQuantity('INCREMENT')}>
                        +
                    </button>
                </div>
                <div className='cartSubtotal text-end'>{`₹${item.price * item.quantity}`}</div>
            </div>
        </div>
    );
};

export default CartItemCard;
